export const CUSTOM_ITERATION_START_NODE = 'custom-iteration-start'
